
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Mail, Smartphone } from 'lucide-react';

export const SitemapCTA = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6, delay: 0.8 }}
      className="text-center mt-20 p-8 bg-gradient-to-r from-juv-soft-blush/20 to-juv-cream-white/50 rounded-2xl border border-[#F2D9D3]/30"
    >
      <h3 className="text-2xl font-bold text-juv-deep-chestnut mb-4">
        Need help navigating JUV?
      </h3>
      <p className="text-gray-600 mb-6">
        Message us in the app or Contact Us for support.
      </p>
      <div className="flex flex-wrap justify-center gap-4">
        <Link
          to="/contact"
          className="inline-flex items-center px-6 py-3 bg-juv-terracotta text-white rounded-full hover:bg-juv-deep-chestnut transition-colors duration-200"
        >
          <Mail className="w-4 h-4 mr-2" />
          Contact Us
        </Link>
        <Link
          to="/app"
          className="inline-flex items-center px-6 py-3 bg-white border border-juv-terracotta text-juv-terracotta rounded-full hover:bg-juv-soft-blush/20 transition-colors duration-200"
        >
          <Smartphone className="w-4 h-4 mr-2" />
          JUV App
        </Link>
      </div>
    </motion.div>
  );
};
